import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="relative z-10 pt-40 pb-32 text-center" data-testid="not-found-page">
            <div className="label-caps text-[#8C3A3A] mb-4">404</div>
            <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1A1A1A] mb-8">This page isn't here.</h1>
            <Link to="/gallery" className="text-[#5A5A5A] hover:text-[#1A1A1A] nav-link" data-testid="not-found-gallery-link">Browse the gallery →</Link>
        </div>
    );
}
